import React, { useEffect, useState } from 'react'
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from 'reactstrap'
import moment from 'moment';

// @components
import { FileUpload } from 'components/FileUpload/FileUpload';

// @constantes
import { CAMPOS_PROGRAMA, LABELS_PROGRAMA } from './constantes'

export const ProgramaRegistroCalificacion = ({
  navigation,
  programaAcademico,
  actualizarProgramaAcademico,
  guardarPrograma
}) => {
  /**
   * Stados
   */
  const [debeMostrarBotonGuardar, setDebeMostrarBotonGuardar] = useState(false)
  const [deshabilitarBotonPrincipal, setDeshabilitarBotonPrincipal] = useState(true)

  /**
   * valores iniciales
   */
  const tiempoDeValidez =
    moment(programaAcademico[CAMPOS_PROGRAMA.RC_FECHA_REGISTRO])
      .to(programaAcademico[CAMPOS_PROGRAMA.RC_FECHA_VENCIMIENTO], true)

  /**
   * Efectos
   */
  useEffect(() => {
    const elProgramaEstaAcreditado = !!programaAcademico[CAMPOS_PROGRAMA.PROGRAMA_ACREDITADO]
    setDebeMostrarBotonGuardar(!elProgramaEstaAcreditado)

    const campoSinLlenar =
      !programaAcademico[CAMPOS_PROGRAMA.RC_FECHA_REGISTRO]
      || !programaAcademico[CAMPOS_PROGRAMA.RC_FECHA_VENCIMIENTO]
      || !programaAcademico[CAMPOS_PROGRAMA.RC_RESOLUCION]
      || (!programaAcademico[CAMPOS_PROGRAMA.RC_FILES] && !programaAcademico.id)
    
      setDeshabilitarBotonPrincipal(campoSinLlenar)
  }, [programaAcademico])
  

  /**
   * Manejadores
   */
   const manejadorDeCambios = (campo, valor) => {
    actualizarProgramaAcademico(estadoPrevio => ({
      ...estadoPrevio,
      [campo]: valor
    }))
  }
  
  const manejadorFechaRegistro = ({ target: { value } }) => {
    manejadorDeCambios(CAMPOS_PROGRAMA.RC_FECHA_REGISTRO, value)
  }

  const manejadorFechaVencimiento = ({ target: { value } }) => 
    manejadorDeCambios(CAMPOS_PROGRAMA.RC_FECHA_VENCIMIENTO, value)
  
  const manejadorResolucion = ({ target: { value } }) => 
    manejadorDeCambios(CAMPOS_PROGRAMA.RC_RESOLUCION, value)
  
  const manejadorArchivos = ({ target: { files } }) => 
    manejadorDeCambios(CAMPOS_PROGRAMA.RC_FILES, files[0])
  
  const manejadorBotonPrincipal = () =>
    debeMostrarBotonGuardar ? guardarPrograma(navigation) : navigation.next()
    
  return (
    <div className='container mb-3'>
      <h2>Registro de calificación del programa</h2>
      <Form className='mt-4'>
        <Row form>
          <Col md={5} className='mr-4'>
            <FormGroup>
              <Label>{LABELS_PROGRAMA[CAMPOS_PROGRAMA.RC_FECHA_REGISTRO]} *</Label>
              <Input
                type='date' 
                placeholder='NA'
                onChange={manejadorFechaRegistro}
                value={programaAcademico[CAMPOS_PROGRAMA.RC_FECHA_REGISTRO]}
              />
            </FormGroup>
          </Col>
          <Col md={5} className='mr-4'>
            <FormGroup>
              <Label>{LABELS_PROGRAMA[CAMPOS_PROGRAMA.RC_FECHA_VENCIMIENTO]} *</Label>
              <Input
                type='date' 
                placeholder='NA'
                onChange={manejadorFechaVencimiento}
                value={programaAcademico[CAMPOS_PROGRAMA.RC_FECHA_VENCIMIENTO]}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row form>
          <Col md={5} className='mr-4'>
            <FormGroup>
              <Label>{LABELS_PROGRAMA[CAMPOS_PROGRAMA.RC_RESOLUCION]} *</Label>
              <Input
                type='number'
                placeholder='...'
                onChange={manejadorResolucion}
                value={programaAcademico[CAMPOS_PROGRAMA.RC_RESOLUCION] || ''}
              />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup className='mt-4' check inline>
              <Label check>Timpo de validez: <strong>{tiempoDeValidez}</strong></Label>
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col className='mr-4'>
            <FormGroup>
              <Label>{LABELS_PROGRAMA[CAMPOS_PROGRAMA.RC_FILES]} *</Label>
              <div style={{ display: 'flex', gap: '10px' }}>
                <FileUpload
                  id={CAMPOS_PROGRAMA.RC_FILES}
                  onChange={manejadorArchivos}
                  value={programaAcademico[CAMPOS_PROGRAMA.RC_FILES]?.name}
                >
                  {programaAcademico[CAMPOS_PROGRAMA.RC_FILES]?.name}
                </FileUpload>
              </div>
            </FormGroup>
          </Col>
        </Row>
      </Form>

      <div className='mt-3'>
        <Button
          variant='contained'
          color='danger'
          onClick={() => navigation.previous()}
        >
          Atras
        </Button>

        <Button
          className='ml-2'
          variant='contained'
          color='primary'
          onClick={manejadorBotonPrincipal}
          disabled={deshabilitarBotonPrincipal}
        >
          {debeMostrarBotonGuardar ? 'Guardar' : 'Siguiente'}
        </Button>
        
      </div>
    </div>
  )
}
